import React from 'react'

export default function YellowHeader({title}) {
  return (
    <div className="col-12 theme-light-yellow p-4 rounded theme-font-blue">
        <h2>{ title }</h2>
    </div>
  )
}
